module.exports = __webpack_public_path__ + "fa-brands-400.9d56249d09070f656a1c.woff";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-brands-400.woff
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-brands-400.woff
// module chunks = styles